import { render, staticRenderFns } from "./FaceIdent.vue?vue&type=template&id=3c64d7f6&scoped=true&"
import script from "./FaceIdent.vue?vue&type=script&lang=js&"
export * from "./FaceIdent.vue?vue&type=script&lang=js&"
import style0 from "./FaceIdent.vue?vue&type=style&index=0&id=3c64d7f6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c64d7f6",
  null
  
)

export default component.exports